import React, { Component } from "react";

import classnames from "classnames";
import DropdownMultiSelectFilter from "QuotePage/app/compactQuotePage/plansFilterPanel/plansFilterPanelDumb/DropdownMultiSelectFilter";
import { carrierOptions, EMPTY_FILTERS } from "QuotePage/app/compactQuotePage/shared/FilterData";
import SingleOptionFilter from "QuotePage/app/compactQuotePage/shared/SingleOptionFilter";
import { connect } from "react-redux";
import _ from "underscore";

import { DropdownButton } from "Cobalt/Dropdown";

import { setDentalFilter } from "./Actions";
import { getDentalFilterConfig, getAllDentalPlans } from "./Selectors";

import type { Dispatch } from "redux";
import type { DentalPlan } from "Utils/types";

type Props = {
  filterConfig: any;
  onChangeFilter: (arg0: string, arg1: any) => void;
  allPlans: Array<DentalPlan>;
};

export class PlansFilterPanelDumb extends Component<Props> {
  render() {
    return (
      <div className="flex flex-row scroll-auto gap-3 justify-end items-center">
        {this.renderMaxBenefitFilter()}
        {this.renderCarrierFilter()}
        {this.renderNetworkFilter()}
        {this.renderStandaloneBracesFilter()}
      </div>
    );
  }

  renderDeductibleFilter() {
    const { filterConfig, onChangeFilter } = this.props;
    const options = [
      { label: "$0", value: { min: 0, max: 0 } },
      { label: "$25", value: { min: 1, max: 25 } },
      { label: "$50", value: { min: 26, max: 50 } },
      { label: "$51 and above", value: { min: 51, max: 9999 } },
    ];

    return (
      <DropdownMultiSelectFilter
        filterConfig={filterConfig}
        onChangeFilter={onChangeFilter}
        options={options}
        defaultOptions={options.map((x) => x.value)}
        defaultSelect
        filterKey="deductible"
        menuTitle="Deductible"
      />
    );
  }

  renderCarrierFilter() {
    const { filterConfig, onChangeFilter } = this.props;
    const options = carrierOptions(this.uniqueCarriers());
    return (
      <DropdownMultiSelectFilter
        filterConfig={filterConfig}
        onChangeFilter={onChangeFilter}
        options={options}
        defaultOptions={options.map((x) => x.value)}
        defaultSelect
        filterKey="carrier"
        menuTitle="Carriers"
      />
    );
  }

  renderNetworkFilter() {
    const { filterConfig, onChangeFilter } = this.props;
    const options = carrierOptions(this.uniquePlanTypes());
    return (
      <DropdownMultiSelectFilter
        filterConfig={filterConfig}
        onChangeFilter={onChangeFilter}
        options={options}
        defaultOptions={options.map((x) => x.value)}
        defaultSelect
        filterKey="plan_type"
        menuTitle="Network Type"
      />
    );
  }

  renderMaxBenefitFilter() {
    const { filterConfig, onChangeFilter } = this.props;
    const options = [
      { label: "$0 to $500", value: { min: 0, max: 500 } },
      { label: "$501 to $1,000", value: { min: 501, max: 1000 } },
      { label: "$1,001 to $1,500", value: { min: 1001, max: 1500 } },
      { label: "$1,501 and above", value: { min: 1501, max: 999999999 } },
    ];

    return (
      <DropdownMultiSelectFilter
        filterConfig={filterConfig}
        onChangeFilter={onChangeFilter}
        options={options}
        defaultOptions={options.map((x) => x.value)}
        defaultSelect
        filterKey="annual_maximum"
        menuTitle="Max Benefit"
      />
    );
  }

  renderStandaloneBracesFilter() {
    const { filterConfig, onChangeFilter, allPlans } = this.props;
    const isSelected = filterConfig.braces_covered.include?.[0] === true;
    return (
      <DropdownButton
        title="Braces Coverage"
        size="small"
        color={isSelected ? "secondary" : "white"}
        round
        className={classnames("block border-solid border-transparent", {
          "border-blue hover:border-blue": isSelected,
        })}
        type="filter"
        dropdownClassName="rounded-xl"
        p={3}
        keepOpenOnSelect={false} // because only one option here
        dropdownPosition="right"
      >
        <SingleOptionFilter
          filterConfig={filterConfig}
          allPlans={allPlans}
          filterKey="braces_covered"
          handleChangeFilter={onChangeFilter}
          filterLabel="Covered"
          disableFilterCountIndicator
        />
      </DropdownButton>
    );
  }

  uniqueCarriers() {
    return _.uniq(this.props.allPlans.map((p) => p.carrier)).sort() || [];
  }

  uniquePlanTypes() {
    return _.uniq(this.props.allPlans.map((p) => p.plan_type)).sort() || [];
  }
}

function mapStateToProps(state) {
  return {
    allPlans: getAllDentalPlans(state),
    filterConfig: getDentalFilterConfig(state) || EMPTY_FILTERS.dentalFilter,
  };
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
  return {
    onChangeFilter: (field, rawValue) => {
      dispatch(setDentalFilter(field, rawValue));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PlansFilterPanelDumb);
